import { InjectionToken } from '@angular/core';

// Create the injection token for the custom config
export const APP_CONFIG = new InjectionToken('appCustomConfig');
